import { render, staticRenderFns } from "./MAAdetail.vue?vue&type=template&id=659b4f7d&scoped=true"
import script from "./MAAdetail.vue?vue&type=script&lang=js"
export * from "./MAAdetail.vue?vue&type=script&lang=js"
import style0 from "./MAAdetail.vue?vue&type=style&index=0&id=659b4f7d&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "659b4f7d",
  null
  
)

export default component.exports